export default __webpack_public_path__ + "static/media/icon.511370af.svg";